<template>
  <div class="photo-detail">
    <div class="photo-container">
      <div class="photo-content">
        <div class="photo-main">
          <div class="image-wrapper">
            <img :src="photoInfo.watermarkImageUrl" :alt="photoInfo.imageName" class="preview-image" @click="showImg">
            <div v-if="isLoggedIn && photoInfo.threeDModelUrl" class="model-preview-btn-container">
               <el-tooltip :content="!has3dPermission ? '您当前没有权限，请联系管理员开通' : '预览3D模型'" placement="top" :disabled="has3dPermission">
                 <div class="tooltip-wrapper">
                   <button
                     class="model-preview-btn"
                     :class="{ 'disabled': !has3dPermission }"
                     @click="handlePreview3d"
                   >
                     <i class="fas fa-cube"></i> 预览3D模型
                   </button>
                 </div>
               </el-tooltip>
            </div>
          </div>

          <!-- 图片在线改色功能区域 -->
          <div v-if="showColorChanger" class="color-changer-container">
            <!-- 演示视频封面 - 使用自定义图片并添加播放按钮 -->
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; background-color: #f8f9fa; border-radius: 8px; padding-left: 15px; padding-right: 15px; box-shadow: 0 2px 6px rgba(0,0,0,0.05);" id="abc">
              <div style="flex: 1; padding-right: 15px;">
                <p style="font-size: 18px; font-weight: bold; color: #2196F3; margin-bottom: 10px;">专属客服福利</p>
                <p style="font-size: 14px; color: #555; margin-bottom: 8px;"><i class="fas fa-gift" style="color: #ff6b6b; margin-right: 5px;"></i>联系客服享受充值优惠</p>
                <p style="font-size: 14px; color: #555; margin-bottom: 0;"><i class="fas fa-coins" style="color: #ffc107; margin-right: 5px;"></i>充值越多送的越多</p>
              </div>
              <div class="video-tutorial-cover" @click="openVideoTutorial">
                <img src="/demo-video.jpg" alt="图片在线改色教程" class="video-cover-image">
                <div class="play-button-overlay">
                  <div class="play-button">
                    <i class="fas fa-play"></i>
                  </div>
                </div>
              </div>
            </div>

            <div class="color-changer-header">
              <div class="header-left">
                <h3>
                  <i class="fas fa-palette" style="color: #2196F3; margin-right: 8px;"></i>
                  图片在线改色
                </h3>
                <div class="header-info">
                  <span class="cost-info">
                    <i class="fas fa-coins" style="color: #ffc107;"></i>
                    每次改色消耗 <strong>{{ colorChangeCost }}</strong> 虚拟豆
                  </span>
                  <span class="balance-info">
                    <i class="fas fa-wallet" style="color: #4caf50;"></i>
                    当前余额：<strong>{{ coinBalance }}</strong> 虚拟豆
                  </span>
                </div>
              </div>
              <button class="close-btn" @click="closeColorChanger">
                <i class="fas fa-times"></i>
              </button>
            </div>

            <div class="color-changer-controls">
              <div class="control-group">
                <button class="control-btn add-region-btn" @click="addColorRegion">
                  <i class="fas fa-plus"></i> 添加改色区域
                </button>
                <button class="control-btn" @click="clearSelection">
                  <i class="fas fa-trash"></i> 清除所有
                </button>
              </div>
            </div>

            <!-- 改色区域列表 -->
            <div class="color-regions-container" v-if="colorRegions.length > 0">
              <h4>改色区域 ({{ colorRegions.length }})</h4>
              <div class="color-regions-list">
                <div v-for="(region, index) in colorRegions" :key="index" class="color-region-item">
                  <div class="region-header">
                    <span>区域 #{{ index + 1 }}</span>
                    <button class="remove-region-btn" @click="removeRegion(index)">
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                  <div class="region-content">
                    <div class="region-image-upload" v-if="!region.preview">
                      <input type="file" accept="image/*" @change="(e) => handleRegionImageSelect(e, index)"
                        class="file-input" :ref="`fileInput_${index}`">
                      <button class="upload-btn" @click="triggerRegionFileInput(index)">
                        <i class="fas fa-image"></i> 选择图片
                      </button>
                    </div>
                    <div class="region-image-preview" v-else>
                      <img :src="region.preview" alt="区域图片预览" />
                      <button class="change-image-btn" @click="triggerRegionFileInput(index)">
                        <i class="fas fa-exchange-alt"></i> 更换图片
                      </button>
                      <input type="file" accept="image/*" @change="(e) => handleRegionImageSelect(e, index)"
                        class="file-input" :ref="`fileInput_${index}`" style="display: none;">
                    </div>
                    <div class="region-color-picker">
                      <label>选择颜色</label>
                      <div class="color-picker-container">
                        <input type="color" v-model="region.color" class="color-picker">
                        <input type="text" v-model="region.color" class="color-input" placeholder="#RRGGBB">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="control-group apply-btn-container">
              <button class="apply-btn" @click="applyColorChange" :disabled="!isAllRegionsReady() || isProcessing">
                <i class="fas" :class="isProcessing ? 'fa-spinner fa-spin' : 'fa-paint-brush'"></i>
                {{ isProcessing ? '处理中...' : '应用改色' }}
              </button>
            </div>

            <div v-if="newImageUrl" class="new-image-preview">
              <h4>改色后效果</h4>
              <img :src="newImageUrl" alt="改色后图片" class="new-image">
              <button class="download-btn" @click="downloadNewImage">
                <i class="fas fa-download"></i> 下载图片
              </button>
            </div>
          </div>
        </div>

        <div class="photo-sidebar">
          <div class="photo-info">
            <h1>{{ photoInfo.imageName }}</h1>
            <div class="meta-info">
              <span class="meta-item">
                <i class="fas fa-file"></i>
                {{ formatFileSize(photoInfo.fileSize) }}
              </span>
              <span class="meta-item">
                <i class="fas fa-clock"></i>
                {{ formatDate(photoInfo.uploadTime) }}
              </span>
            </div>
            <div class="meta-info">
              <span class="meta-item">
                <i class="fas fa-eye"></i>
                {{ photoInfo.viewCount }} 次查看
              </span>
            </div>

            <div class="author-info">
              <div class="author-wrapper">
                <div class="author-avatar">
                  <i class="fas fa-user-circle" style="color: cadetblue"></i>
                </div>
                <div class="author-detail">
                  <span class="name">{{ photoInfo.uploaderName }}</span>
                </div>
              </div>
            </div>

            <div class="tags-container">
              <h3>标签</h3>
              <div class="tags">
                <span v-for="tag in (photoInfo.tags ? photoInfo.tags.split(',') : [])" :key="tag" class="tag">
                  <i class="fas fa-tag"></i>
                  {{ tag }}
                </span>
              </div>
            </div>

            <div class="action-buttons">
              <button v-if="isLoggedIn" class="favorite-btn" :class="{ 'is-favorited': isFavorited(photoInfo.imageId) }"
                @click="toggleFavorite(photoInfo.imageId)">
                <i class="fas" :class="isFavorited(photoInfo.imageId) ? 'fa-heart' : 'fa-regular fa-heart'"></i>
                {{ isFavorited(photoInfo.imageId) ? '已收藏' : '收藏' }}
              </button>

              <!-- 添加图片在线改色按钮 -->
              <button v-if="isLoggedIn" class="color-change-btn" @click="showColorChangerPanel">
                <i class="fas fa-palette"></i>
                图片在线改色
              </button>

              <template v-if="isLoggedIn">
                <button v-if="functions.indexOf('imageDownload') >= 0" class="download-btn" @click="downloadImage">
                  <i class="fas fa-download"></i>
                  下载图片
                </button>
                <template v-else>
                  <a v-if="functions.indexOf('imageDownload') < 0"
                    :href="`/#/membership?returnUrl=/#/photos/${this.photoInfo.imageId}`" class="upgrade-btn">
                    <i class="fas fa-crown"></i>
                    开通会员下载图片
                  </a>
                </template>

                <button v-if="functions.indexOf('sourceFileDownload') >= 0 && photoInfo.sourceFile"
                  class="download-btn source" @click="openSourceImage">
                  <i class="fas fa-file-download"></i>
                  下载源文件
                </button>
                <div class="meta-info" v-if="userVipType >= 2 && photoInfo.sourceFileExtractCode">
                  <span class="meta-item">
                    <i class="fas fa-key"></i>
                    源文件提取码：{{ photoInfo.sourceFileExtractCode }}
                  </span>
                </div>
              </template>
              <template v-else>
                <a v-if="functions.indexOf('sourceFileDownload') < 0"
                  :href="`/#/membership?returnUrl=/#/photos/${this.photoInfo.imageId}`" class="upgrade-btn">
                  <i class="fas fa-crown"></i>
                  开通会员下载图片
                </a>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <vue-easy-lightbox :visible="visible" :imgs="[photoInfo.imageUrl]" :index="0"
      @hide="handleHide"></vue-easy-lightbox>

    <!-- 添加充值对话框组件 -->
    <recharge-dialog :visible="showRechargeDialog" :returnUrl="currentUrl" :cost="colorChangeCost"
      @close="showRechargeDialog = false" />

    <!-- 3D 模型预览弹窗 -->
    <div v-if="show3dModal" class="modal-overlay" @click.self="show3dModal = false">
      <div class="modal-content modal-3d">
        <button class="modal-close" @click="show3dModal = false">
          <i class="fas fa-times"></i>
        </button>
        <div class="modal-body-3d">
          <three-viewer
            :modelUrl="dynamic3dModelUrl"
            :authToken="token"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueEasyLightbox from 'vue-easy-lightbox'
import { favoritesMixin } from '@/mixins/favoritesMixin'
import { request } from '@/utils/request'
import RechargeDialog from '@/components/RechargeDialog.vue'
import ThreeViewer from '@/components/ThreeViewer.vue'

export default {
  name: 'PhotoDetailView',
  components: {
    VueEasyLightbox,
    RechargeDialog,
    ThreeViewer
  },
  mixins: [favoritesMixin],
  data() {
    return {
      photoInfo: {
        imageId: '',
        imageName: '',
        imageUrl: '',
        fileSize: 0,
        viewCount: 0,
        uploadTime: '',
        tags: '',
        uploaderName: ''
      },
      visible: false,
      isLoggedIn: false,
      userVipType: 0,
      functions: [],
      // 图片在线改色相关数据
      showColorChanger: false,
      selectedColor: '#FF0000',
      clipFileIds: [],
      newImageUrl: '',
      isProcessing: false,
      // 新增：已选择图片列表
      selectedImages: [],
      // 新增：充值对话框显示控制
      showRechargeDialog: false,
      // 新增：当前URL（用于充值后返回）
      currentUrl: '',
      // 新增：图片改色功能配置
      colorChangeCost: 0,
      // 新增：用户虚拟豆余额
      coinBalance: 0,
      colorRegions: [],
      // 新增：视频教程URL
      videoTutorialUrl: '/demo-video.mp4',
      // 新增：3D模型预览弹窗控制
      show3dModal: false,
      token: '',
      dynamic3dModelUrl: ''
    }
  },
  computed: {
    has3dPermission() {
      return this.functions.includes('3dModelView');
    }
  },
  mounted() {
    this.token = localStorage.getItem('token') || '';
    this.loadPhotoInfo()
    this.loadFavorites()
    this.checkLoginStatus()
    this.currentUrl = window.location.href // 保存当前URL
    this.loadColorChangeConfig() // 加载图片改色功能配置
  },

  methods: {
    // 打开视频教程
    openVideoTutorial() {
      window.open(this.videoTutorialUrl, '_blank')
    },

    handlePreview3d() {
      if (!this.has3dPermission) {
        // 权限不足时不执行操作，已通过title提示
        return;
      }

      // Fetch dynamic 3D model URL
      this.fetch3dModelUrl(this.photoInfo.imageId).then(url => {
        if (url) {
          this.dynamic3dModelUrl = url;
          this.show3dModal = true;
        } else {
          this.$message.error('获取3D模型链接失败');
        }
      });
    },

    async fetch3dModelUrl(imageId) {
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(`/api/image/3d/view/${imageId}`, {
          method: 'GET',
          headers: {
            'x-access-token': token
          }
        });
        const data = await response.json();
        if (data.ok) {
          return data.data; // Assuming data.data contains the new URL
        }
        return null;
      } catch (error) {
        console.error('Failed to fetch 3D model URL:', error);
        return null;
      }
    },

    async loadColorChangeConfig() {
      try {
        const response = await request('/api/coin/feature/image_color_change/config')
        if (response.ok) {
          this.colorChangeCost = response.data.cost || 0
        } else {
          console.error('获取图片改色功能配置失败:', response.msg)
        }
      } catch (error) {
        console.error('获取图片改色功能配置失败:', error)
      }
    },
    async loadPhotoInfo() {
      try {
        const imageId = this.$route.params.id
        const token = localStorage.getItem('token')
        const response = await fetch(`/api/image/info/${imageId}`, {
          method: 'GET',
          headers: {
            'x-access-token': token
          }
        })
        const data = await response.json()
        if (data.ok) {
          this.photoInfo = {
            ...data.data,
          }
        }
      } catch (error) {
        console.error('加载图片详情失败:', error)
      }
    },
    async checkLoginStatus() {
      this.isLoggedIn = !!localStorage.getItem('token')
      if (this.isLoggedIn) {
        const statusResponse = await request(`/api/auth/self`);
        if (statusResponse.ok) {
          this.userVipType = statusResponse.data.vipType || ''
          this.functions = statusResponse.data.functions || []
          this.coinBalance = statusResponse.data.coinBalance || 0 // 获取用户虚拟豆余额
        }
      }
    },
    formatFileSize(size) {
      if (size < 1024) return size + ' B'
      if (size < 1024 * 1024) return (size / 1024).toFixed(2) + ' KB'
      return (size / (1024 * 1024)).toFixed(2) + ' MB'
    },
    formatDate(dateString) {
      const date = new Date(dateString)
      return date.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    },
    showImg() {
      this.visible = true
    },
    handleHide() {
      this.visible = false
    },
    async downloadImage() {
      try {
        const token = localStorage.getItem('token')
        const response = await fetch(`/api/image/download/${this.photoInfo.imageId}`, {
          method: 'GET',
          headers: {
            'x-access-token': token
          }
        })

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        const contentDisposition = response.headers.get('content-disposition')
        let filename = this.photoInfo.imageName

        if (contentDisposition) {
          // 优先使用 filename*=UTF-8''xxx
          const filenameStarMatch = contentDisposition.match(/filename\*=UTF-8''(.+?)(;|$)/)
          if (filenameStarMatch && filenameStarMatch[1]) {
            filename = decodeURIComponent(filenameStarMatch[1])
          } else {
            // fallback: 尝试从 filename="xxx" 中取出
            const filenameMatch = contentDisposition.match(/filename="?([^";]+)"?/)
            if (filenameMatch && filenameMatch[1]) {
              const iso88591Bytes = new TextEncoder('iso-8859-1').encode(filenameMatch[1])
              filename = new TextDecoder('utf-8').decode(iso88591Bytes)
            }
          }
        }

        const blob = await response.blob()
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = filename // 使用从响应头获取的文件名
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)

        this.$message.success('下载成功')
      } catch (error) {
        console.error('下载图片失败:', error)
        this.$message.error('下载失败')
      }
    },
    openSourceImage() {
      window.open(this.photoInfo.sourceFile, '_blank')
    },

    // 图片在线改色相关方法
    showColorChangerPanel() {
      // 检查用户虚拟豆余额是否足够
      if (this.coinBalance < this.colorChangeCost) {
        this.showRechargeDialog = true
        this.$message.error(`虚拟豆余额不足，改色需要${this.colorChangeCost}虚拟豆，当前余额${this.coinBalance}虚拟豆`)
        return
      }
      this.showColorChanger = true
      this.addColorRegion()
    },
    closeColorChanger() {
      this.showColorChanger = false
      this.clipFileIds = []
      this.selectedImages = []
      this.newImageUrl = ''
    },
    triggerFileInput() {
      this.$refs.fileInput.click()
    },
    // 添加一个新的改色区域
    addColorRegion() {
      this.colorRegions.push({
        file: null,
        preview: '',
        color: this.selectedColor // 使用当前选择的颜色作为默认值
      })
    },

    // 触发特定区域的文件选择
    triggerRegionFileInput(index) {
      const refName = `fileInput_${index}`;
      if (this.$refs[refName] && this.$refs[refName][0]) {
        this.$refs[refName][0].click();
      }
    },

    // 处理区域图片选择
    handleRegionImageSelect(event, index) {
      const files = event.target.files
      if (!files || files.length === 0) return

      const file = files[0]
      if (!file.type.startsWith('image/')) {
        this.$message.error('请选择图片文件')
        return
      }

      // 添加图片大小限制检查 (限制为2MB)
      const maxSize = 10 * 1024 * 1024 // 10MB
      if (file.size > maxSize) {
        this.$message.error('图片大小不能超过10MB')
        return
      }

      // 创建预览
      const reader = new FileReader()
      reader.onload = (e) => {
        // 更新对应区域的图片信息
        this.colorRegions[index].file = file
        this.colorRegions[index].preview = e.target.result
      }
      reader.readAsDataURL(file)

      // 清空文件输入，以便可以重复选择同一文件
      event.target.value = ''
    },

    // 移除指定索引的区域
    removeRegion(index) {
      this.colorRegions.splice(index, 1)
    },

    // 清空所有区域
    clearSelection() {
      this.colorRegions = []
      this.clipFileIds = []
    },

    // 检查所有区域是否都已准备好（有图片和颜色）
    isAllRegionsReady() {
      if (this.colorRegions.length === 0) return false

      for (const region of this.colorRegions) {
        if (!region.file || !region.preview) return false
      }

      return true
    },
    async applyColorChange() {
      if (!this.isAllRegionsReady()) {
        this.$message.warning('请确保所有区域都已选择图片')
        return
      }

      // 检查用户虚拟豆余额是否足够
      if (this.coinBalance < this.colorChangeCost) {
        this.showRechargeDialog = true
        this.$message.error(`虚拟豆余额不足，改色需要${this.colorChangeCost}虚拟豆，当前余额${this.coinBalance}虚拟豆`)
        return
      }

      this.isProcessing = true
      this.newImageUrl = ''
      const formData = new FormData()
      formData.append('imageId', this.photoInfo.imageId)
      for (let i = 0; i < this.colorRegions.length; i++) {
        const region = this.colorRegions[i]
        const color = (region.color || '').replace('#', '')
        formData.append('newColors', color)
        formData.append('files', region.file, region.file.name)
      }

      try {
        const token = localStorage.getItem('token')
        const response = await fetch(`/api/image/changeColor/multi`, {
          method: 'POST',
          headers: { 'x-access-token': token },
          body: formData
        })

        const data = await response.json()
        if (data.ok) {
          this.newImageUrl = data.data
          this.$message.success('改色成功')
          this.coinBalance -= this.colorChangeCost
        } else {
          if (data.code === 40001) {
            this.showRechargeDialog = true
            this.$message.error(data.msg || '虚拟豆余额不足')
          } else {
            this.$message.error(data.msg || '改色失败')
          }
        }
      } catch (error) {
        console.error('改色请求失败:', error)
        this.$message.error(error.message || '改色失败')
      } finally {
        // 无论成功或失败，都将处理状态设置为false
        this.isProcessing = false
      }
    },
    async downloadNewImage() {
      if (!this.newImageUrl) return

      try {
        const response = await fetch(this.newImageUrl)
        const blob = await response.blob()
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `改色_${this.photoInfo.imageName}`
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)

        this.$message.success('下载成功')
      } catch (error) {
        console.error('下载改色图片失败:', error)
        this.$message.error('下载失败')
      }
    }
  }
}
</script>

<style scoped>
.photo-detail {
  max-width: 1200px;
  margin: 40px auto;
  padding: 0 20px;
}

.photo-container {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

/* 视频教程封面样式 */
.video-tutorial-cover {
  /* margin: 20px 0; */
  margin-bottom: 15px;
  border-radius: 6px;
  cursor: pointer;
  overflow: hidden;
  transition: transform 0.3s ease;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
  position: relative;
  max-width: 30%;
  /* 限制最大宽度 */
  margin-left: auto;
  /* margin-right: auto; */
}

.video-tutorial-cover:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.video-cover-image {
  width: 100%;
  display: block;
}

.play-button-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.3);
  opacity: 0.8;
  transition: opacity 0.3s ease;
}

.video-tutorial-cover:hover .play-button-overlay {
  opacity: 1;
}

.play-button {
  width: 50px;
  /* 减小播放按钮尺寸 */
  height: 50px;
  /* 减小播放按钮尺寸 */
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s ease;
}

.play-button i {
  font-size: 22px;
  /* 减小图标尺寸 */
  color: #2196F3;
  margin-left: 3px;
  /* 稍微偏右以视觉居中 */
}

.video-tutorial-cover:hover .play-button {
  transform: scale(1.1);
}

.photo-content {
  display: flex;
  gap: 30px;
  padding: 30px;
}

.photo-main {
  flex: 1;
  min-width: 0;
  position: relative;
}

.photo-sidebar {
  width: 300px;
  flex-shrink: 0;
}

.preview-image {
  width: 100%;
  max-height: 70vh;
  object-fit: contain;
  background: #f5f5f5;
  cursor: zoom-in;
  transition: transform 0.3s ease;
}

.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 20px;
}

.favorite-btn,
.download-btn,
.upgrade-btn,
.color-change-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 20px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
  width: 100%;
  text-decoration: none;
}

.favorite-btn {
  background: #f5f5f5;
  color: #666;
}

.favorite-btn:hover,
.favorite-btn.is-favorited {
  background: #ffebee;
  color: #f44336;
}

.download-btn {
  background: #4CAF50;
  color: white;
}

.download-btn:hover {
  background: #43A047;
}

.upgrade-btn {
  background: #FF7043;
  color: white;
}

.upgrade-btn:hover {
  background: #F4511E;
}

.color-change-btn {
  background: #2196F3;
  color: white;
}

.color-change-btn:hover {
  background: #1E88E5;
}

.preview-image:hover {
  transform: scale(1.01);
}

.photo-actions {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 2;
}

.favorite-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  cursor: pointer;
  color: #666;
  font-size: 14px;
  transition: all 0.3s ease;
}

.favorite-btn:hover {
  background: white;
  color: #f44336;
}

.favorite-btn.is-favorited {
  color: #f44336;
}

.favorite-btn i {
  font-size: 18px;
}

.photo-info {
  padding: 24px;
}

.photo-info h1 {
  margin: 0 0 16px;
  font-size: 24px;
  color: #333;
}

.meta-info {
  display: flex;
  gap: 24px;
  margin-bottom: 16px;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #666;
  font-size: 14px;
}

.meta-item .fa-key {
  color: #ffc107;
}

.tags-container {
  margin: 24px 0;
}

.tags-container h3 {
  margin-bottom: 12px;
  color: #333;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: #f5f5f5;
  border-radius: 16px;
  font-size: 14px;
  color: #666;
}

.tag i {
  color: #4CAF50;
  font-size: 12px;
}

.author-info {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #eee;
}

.author-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
}

.author-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  flex-shrink: 0;
}

.author-avatar i {
  font-size: 40px;
  color: #999;
}

.author-detail {
  display: flex;
  align-items: center;
}

.author-detail .name {
  font-weight: 500;
  color: #333;
  font-size: 15px;
}

.download-btn.source {
  background-color: #ea697d;
}

.download-btn.source:hover {
  background-color: #215888;
}

/* 图片在线改色相关样式 */
.color-changer-container {
  margin-top: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 20px;
  background: #f9f9f9;
}

.color-changer-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  gap: 15px;
  padding-bottom: 15px;
  border-bottom: 2px solid #e0e0e0;
}

.header-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.color-changer-header h3 {
  margin: 0;
  font-size: 20px;
  color: #333;
  display: flex;
  align-items: center;
}

.header-info {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.cost-info,
.balance-info {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  padding: 6px 12px;
  border-radius: 20px;
  background-color: #f5f5f5;
  transition: all 0.3s ease;
}

.cost-info:hover {
  background-color: #fff3e0;
  box-shadow: 0 2px 4px rgba(255, 152, 0, 0.2);
}

.balance-info:hover {
  background-color: #e8f5e9;
  box-shadow: 0 2px 4px rgba(76, 175, 80, 0.2);
}

.cost-info {
  color: #ff9800;
  border: 1px solid rgba(255, 152, 0, 0.2);
}

.balance-info {
  color: #4caf50;
  border: 1px solid rgba(76, 175, 80, 0.2);
}

.color-changer-header h3 {
  margin: 0;
  font-size: 20px;
  color: #333;
  display: flex;
  align-items: center;
}

.close-btn {
  background: none;
  border: 2px solid transparent;
  color: #999;
  cursor: pointer;
  font-size: 20px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.close-btn:hover {
  background-color: #ffebee;
  color: #f44336;
  border-color: #ffcdd2;
  transform: rotate(90deg);
}

.image-container {
  width: 100%;
  max-height: 400px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 15px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.original-image {
  max-width: 100%;
  max-height: 400px;
  object-fit: contain;
}

.file-input {
  display: none;
}

.color-changer-controls {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 20px;
}

.control-group {
  flex: 1;
  min-width: 200px;
  display: flex;
}

.control-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
}

.control-btn {
  padding: 8px 16px;
  background: #f0f0f0;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 8px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.control-btn:hover {
  background: #e0e0e0;
}

.color-picker-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.color-picker {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.color-input {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 100px;
}

.apply-btn {
  padding: 10px 20px;
  background: #2196F3;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
}

.apply-btn:hover {
  background: #1E88E5;
}

.apply-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.new-image-preview {
  margin-top: 20px;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: white;
}

.new-image-preview h4 {
  margin-top: 0;
  margin-bottom: 10px;
  color: #333;
}

.new-image {
  width: 100%;
  max-height: 400px;
  object-fit: contain;
  margin-bottom: 15px;
  border: 1px solid #eee;
}

/* 修改样式以适应每张图片对应一个颜色 */
.selected-images-container {
  margin: 20px 0;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 15px;
  background-color: #f9f9f9;
}

.selected-images-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 15px;
  max-height: 400px;
  overflow-y: auto;
}

.selected-image-item {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 10px;
  background-color: white;
}

.selected-image-preview {
  width: 100%;
  height: 120px;
  overflow: hidden;
  border-radius: 4px;
  margin-bottom: 10px;
}

.selected-image-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.selected-image-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.color-picker-container {
  display: flex;
  align-items: center;
  gap: 5px;
}

.color-picker {
  width: 30px;
  height: 30px;
  border: none;
  padding: 0;
  background: none;
  cursor: pointer;
}

.color-input {
  width: 80px;
  padding: 4px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
}

.remove-image-btn {
  background: none;
  border: none;
  color: #f44336;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
}

.remove-image-btn:hover {
  background-color: #ffebee;
}

.apply-btn-container {
  margin-top: 20px;
}

.apply-btn {
  width: 100%;
  padding: 12px;
  background-color: #2196F3;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 16px;
}

.apply-btn:hover:not(:disabled) {
  background-color: #1E88E5;
}

.apply-btn:disabled {
  background-color: #B0BEC5;
  cursor: not-allowed;
}

.add-region-btn {
  background-color: #4caf50;
  color: white;
}

.color-region-item {
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f9f9f9;
  max-width: 100%;
  /* 确保不超出容器 */
}

.region-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  font-weight: bold;
}

.remove-region-btn {
  background: none;
  border: none;
  color: #f44336;
  cursor: pointer;
  font-size: 16px;
}

.region-content {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.region-image-upload,
.region-image-preview {
  flex: 1;
  min-width: 200px;
  position: relative;
}

.region-image-preview img {
  width: 50%;
  /* max-height: 120px; */
  /* object-fit: contain; */
  border: 1px solid #ddd;
  border-radius: 4px;
  object-fit: cover;
}

.change-image-btn {
  margin-top: 5px;
  background-color: #2196F3;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 4px;
  cursor: pointer;
  width: 51%;
}

.region-color-picker {
  flex: 1;
  min-width: 150px;
}

.upload-btn {
  background-color: #2196F3;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 10px;
}

@media (max-width: 768px) {
  .photo-detail {
    margin: 20px auto;
  }

  .photo-content {
    flex-direction: column;
  }

  .photo-sidebar {
    width: 100%;
  }

  .photo-info {
    padding: 16px;
  }

  .photo-info h1 {
    font-size: 20px;
  }

  .meta-info {
    flex-direction: column;
    gap: 12px;
  }

  .favorite-btn {
    top: 12px;
    right: 12px;
    padding: 6px 12px;
    font-size: 14px;
  }

  .author-wrapper {
    gap: 8px;
  }

  .color-changer-controls {
    flex-direction: column;
    gap: 15px;
  }

  .canvas-container {
    height: 400px;
  }
}

/* 新增区域相关样式 */
.color-regions-container {
  margin-bottom: 20px;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 15px;
  background-color: #f9f9f9;
}

.color-regions-list {
  max-height: 300px;
  overflow-y: auto;
  /* margin-bottom: 10px; */
}

.color-region-item {
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 10px;
  margin-bottom: 10px;
  background-color: white;
  cursor: pointer;
  transition: all 0.2s ease;
}

.color-region-item.active {
  border-color: #2196F3;
  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.2);
}

.region-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.region-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.color-preview {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.remove-region-btn {
  background: none;
  border: none;
  color: #f44336;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
}

.remove-region-btn:hover {
  background-color: #ffebee;
}

.region-images {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.region-image-item {
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #eee;
}

.remove-image-btn {
  position: absolute;
  top: 2px;
  right: 2px;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  color: white;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  cursor: pointer;
}

.add-region-btn {
  width: 50%;
  padding: 8px;
  background-color: #e3f2fd;
  color: #2196F3;
  border: 1px dashed #2196F3;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.add-region-btn:hover {
  background-color: #bbdefb;
}

.active-region-controls {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
  background-color: white;
}

.image-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
}

.model-preview-btn-container {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
}

.model-preview-btn {
  background: rgba(0, 0, 0, 0.6);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  backdrop-filter: blur(4px);
  transition: all 0.2s;
}

.model-preview-btn:hover {
  background: rgba(33, 150, 243, 0.8);
  border-color: #2196F3;
}

.model-preview-btn.disabled {
  background: rgba(0, 0, 0, 0.4);
  color: #ccc;
  border-color: rgba(255, 255, 255, 0.2);
  cursor: not-allowed;
}

.model-preview-btn.disabled:hover {
  background: rgba(0, 0, 0, 0.4);
  border-color: rgba(255, 255, 255, 0.2);
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  padding: 20px;
}

.modal-content.modal-3d {
  background: #2c3e50;
  border-radius: 12px;
  width: 90vw;
  height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  animation: modalFadeIn 0.3s ease;
}

@keyframes modalFadeIn {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}

.modal-close {
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.modal-close:hover {
  background: rgba(255, 255, 255, 0.4);
}

.modal-body-3d {
  flex: 1;
  width: 100%;
  height: 100%;
  position: relative;
}

.tooltip-wrapper {
  display: inline-block;
}
</style>
